/** Styl komponenty fieldset k tématu Erma */
export const FieldsetStyles = {
  borderColor: 'var(--erma-secondary-220)',
  background: 'var(--erma-primary-0)',
  color: '#333',
  borderRadius: 'var(--erma-border-radius-sm)',
  padding: '0.35em 0.75em 0.625em 0.75em',
  legend: {
    padding: '.5rem .8rem',
    borderColor: 'var(--erma-secondary-220)',
    gap: '.5rem',
    fontWeight: '700',
    background: 'var(--erma-secondary-40)',
    borderRadius: 'var(--erma-border-radius-sm)',
    borderWidth: '1px',
    hover: {
      background: 'var(--erma-secondary-220)'
    }
  }
};
